import { ref } from "vue";
import { defineStore } from "pinia";
import useGatewayApi from "@/composables/useGatewayApi";

export const useAdminStore = defineStore("admin", () => {
  const messages = ref([]);
  const logs = ref([]);
  const loading = ref(false);

  const gatewayApi = useGatewayApi();

  async function getLogs(model: any) {
    let url = `api/v1/core/admin/logs?page=${model.page}&pageSize=${model.pageSize}`;

    if (model.start && model.end) {
      url += `&start=${model.start}&end=${model.end}`;
    }
    if (model.search) {
      url += `&search=${model.search}`;
    }

    loading.value = true;
    try {
      const result = await gatewayApi.get(url);
      logs.value = result;
    } catch (e) {
      logs.value = [];
    } finally {
      loading.value = false;
    }
  }

  async function setMessage() {
    try {
      const result = await gatewayApi.get("api/v1/core/admin/messages");
      messages.value = result;
    } catch (e) {}
  }

  async function addMessage(model: any) {
    return gatewayApi.post("api/v1/core/admin/messages", model);
  }

  async function updateMessage(model: any) {
    return gatewayApi.put("api/v1/core/admin/messages", model);
  }

  async function deleteMessage(model: any) {
    return gatewayApi.del("api/v1/core/admin/messages", model);
  }

  return {
    messages,
    logs,
    loading,
    //
    setMessage,
    addMessage,
    updateMessage,
    deleteMessage,
    getLogs
  };
});
